module.exports = __webpack_public_path__ + "img/huashen.f987947c.png";